/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/return_1_medium'
export default icon
